import { render, staticRenderFns } from "./DataApps.vue?vue&type=template&id=84d92928&"
import script from "./DataApps.vue?vue&type=script&lang=js&"
export * from "./DataApps.vue?vue&type=script&lang=js&"
import style0 from "./DataApps.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84d92928')) {
      api.createRecord('84d92928', component.options)
    } else {
      api.reload('84d92928', component.options)
    }
    module.hot.accept("./DataApps.vue?vue&type=template&id=84d92928&", function () {
      api.rerender('84d92928', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DataApps.vue"
export default component.exports